import { useEffect } from 'react';
import type { Me } from 'eds-common/api/v2';
import { identifyUser } from '@/services/launchdarkly/launchdarkly-client';

export function useLaunchDarklyIdentify(user?: Me | null) {
  useEffect(() => {
    // identifyUser logs its own failures; nothing here depends on the result.
    if (user) identifyUser(user).catch(() => undefined);
  }, [user]);
}
